export default __webpack_public_path__ + "static/media/3757.b0244fba.png";